module.exports = __webpack_public_path__ + "static/img/juhuaR410A.ce5c40b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR410A.jpg
// module id = 2nYn
// module chunks = 1